// @flow
import type { DataLoaderParams } from '../../../types/DataLoaderParams';
import { fetchDataForCatalogPage } from '../../../redux/modules/catalogPage';
import { recordAnalyticsForReviewPageView } from '../../../redux/modules/analytics';

export default ({ match, store }: DataLoaderParams) => {
    const { params } = match;
    const { dispatch } = store;
    const catalogId = params.catalogId;
    return Promise.all([dispatch(fetchDataForCatalogPage(catalogId))]).then(() => {
        return dispatch(recordAnalyticsForReviewPageView());
    });
};
